import {getTrackingDisabled} from '#services/storage'
const initialState = {
  trackingDisabled: getTrackingDisabled(),
}

export default function settings(state = initialState) {
  return state
}
